<template>
    <el-container style="height: 800px;">
        <el-header height="150px">
            <el-row>
                <el-col :span="12" :offset="5">
                    <img src='../../assets/2018_New_Logo.png'
                      height="220px"
                      width="220px">
                </el-col>
            </el-row>
        </el-header>
        <el-main>
            <el-row>
                <el-col :span="18" :offset="3">
                    <h1 class="title-color">永恆生活產品(香港)<br>預訂會議室系統</h1>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="18" :offset="1">
                    <el-form :model="loginForm" :rules="rules" label-width="100px">
                        <el-form-item label="FBO ID" prop="username" size="medium">
                            <el-input v-model="loginForm.username"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password" size="medium">
                            <el-input type="password" v-model="loginForm.password"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-alert
                                :title="loginForm.userError"
                                type="error"
                                v-show="loginForm.userError">
                            </el-alert>
                            <el-button type="primary" @click="onSubmit">登錄</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
// import api from '@/utils/api'
import { login } from '../../utils/api'
export default {
  data () {
    return {
      logo: 'url(' + require('../../assets/2018_New_Logo.png') + ')',
      loginForm: {
        username: '',
        password: '',
        userError: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入FBO ID', trigger: 'blur' },
          { min: 12, max: 12, message: '请输入长度为12位的FBO ID', trigger: 'blur' },
          { pattern: /^852\d{9}$/, message: '请输入正确的FBO ID', trigger: 'blur' }
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 16, message: '请输入长度6位的密码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      var that = this
      const params = {
        username: this.loginForm.username,
        password: this.loginForm.password
      }
      if (params.username && params.password) {
        login(params).then(res => {
          if (res.data.token) {
            localStorage.token = res.data.token
          }
          this.$router.push({name: 'home'})
        }).catch(function (error) {
          console.log(error)
          if ('non_field_errors' in error) {
            that.loginForm.userError = 'FBO ID 或 密碼錯誤'
          }
        })
      }
    }
  }
}
</script>

<style>
.title-color {
  color: #6ebd51;
  font-size: 25px
}
.form-name {
  font-size: 50px
}
.el-main {
  padding: 20px
}
.el-form-item__label {
  font-size: 20px;
  font-weight: 600;
  color: #ffc600
}
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue